/* eslint-disable indent */
import { Anchor, Button, CheckboxCard, PanelHeader, PillButtonGroup, SearchBar } from '@keplerco/core';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { SkillsWidget } from '../../../../assessment-management/group/skills-step/skills.widget';
import { CompanySkillListItemResponse } from '../../../../../models/overmind/company-entity';
import { SelectedSkillsWidget } from '../../../../assessment-management/group/skills-step/selected-skills.widget';

enum PillButtonId {
  FrameworkSkills = 0,
  SelectedSkills = 1,
  ExistingSkills = 2,
}

enum PillButtonDescriptions {
  FrameworkSkills = 'Framework Skills',
  ExistingSkills = 'Existing skills',
  RoleSkills = 'Role skills',
  SelectedSkills = 'Selected skills',
}

export function SelectSkillsLayout({ skills, onBack, onAssign }: { skills: CompanySkillListItemResponse[]; onBack: () => void; onAssign: (selectedSkills: CompanySkillListItemResponse[]) => void }): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedPillButton, setSelectedPillButton] = useState<PillButtonId>(PillButtonId.FrameworkSkills);

  const [query, setQuery] = useState<string>('');
  const [selectedSkills, setSelectedSkills] = useState<CompanySkillListItemResponse[]>();

  const [selectedSkillsCount, setSelectedSkillsCount] = useState<number>(0);

  const [selectAll, setSelectAll] = useState<boolean>(false);

  useEffect(() => {
    setSelectedSkills(skills);
  }, [skills]);

  useEffect(() => {
    selectedPillButton === PillButtonId.SelectedSkills ? setSelectAll(!!selectedSkills?.length) : setSelectAll(false);
  }, [selectedPillButton, selectedSkills]);

  return (
    <div className="panelContent">
      <PanelHeader supertitle="Roles Wizard" title="Select skills" subtitle="Manage the skills you would like to assess" divider />

      <div className="card">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
          <SearchBar loading={loading} label="Search" onInput={event => setQuery((event.target as HTMLInputElement).value)} responsive />

          <div style={{ display: 'flex', gap: 15, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <PillButtonGroup
              backgroundColour="borders_2"
              activeTextColour='text'
              buttons={[
                { id: PillButtonId.FrameworkSkills, label: `${PillButtonDescriptions.FrameworkSkills}`, active: selectedPillButton === PillButtonId.FrameworkSkills },
                { id: PillButtonId.ExistingSkills, label: `${PillButtonDescriptions.ExistingSkills}`, active: selectedPillButton === PillButtonId.ExistingSkills },
                { id: PillButtonId.SelectedSkills, label: `${PillButtonDescriptions.SelectedSkills} (${selectedSkillsCount})`, active: selectedPillButton === PillButtonId.SelectedSkills },
              ]}
              onClick={buttons => setSelectedPillButton(buttons[0].id ?? PillButtonId.FrameworkSkills)}
            />
            <div className={classNames({ invisible: selectedPillButton === PillButtonId.FrameworkSkills || selectedPillButton === PillButtonId.ExistingSkills || (selectedPillButton === PillButtonId.SelectedSkills && !selectedSkills?.length) })}>
              <CheckboxCard
                id="selectAll"
                checked={selectAll}
                onChange={() => {
                  setSelectedSkills([]);
                }}
              >
                <div className="card">Select all</div>
              </CheckboxCard>
            </div>
          </div>

          <div className={classNames({ hidden: selectedPillButton !== PillButtonId.FrameworkSkills })} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <SkillsWidget showRoleSkills={false} learnerSlug={undefined} loading={loading} setLoading={setLoading} query={query} personSkills={[]} roleSkills={[]} selectedSkills={selectedSkills ?? []} setSelectedSkills={setSelectedSkills} searchGlobally />
          </div>

          <div className={classNames({ hidden: selectedPillButton !== PillButtonId.ExistingSkills })} style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <SkillsWidget showRoleSkills={false} learnerSlug={undefined} loading={loading} setLoading={setLoading} query={query} personSkills={[]} roleSkills={[]} selectedSkills={selectedSkills ?? []} setSelectedSkills={setSelectedSkills} />
          </div>


          <div className={classNames({ hidden: selectedPillButton !== PillButtonId.SelectedSkills })}>
            <SelectedSkillsWidget showRoleSkills={false} learnerSlug={undefined} loading={loading} query={query} roleSkills={[]} setSelectedSkillsCount={setSelectedSkillsCount} selectedSkills={selectedSkills ?? []} setSelectedSkills={setSelectedSkills} />
          </div>
        </div>
      </div>

      <footer className="panelFooter">
        <Anchor onClick={onBack}>Back</Anchor>

        <Button type="button" onClick={() => onAssign(selectedSkills ?? [])}>
          Add skills
        </Button>
      </footer>
    </div>
  );
}
